import { Flex } from "@chakra-ui/react"
import { EntityId } from "@jackfruit/common"
import React from "react"
import CloudImageBrowser from "../../common/browser/CloudImageBrowser"
import CloudImageBrowserActionsDesktop from "../../common/browser/CloudImageBrowserActionsDesktop"
import CloudImageBrowserLoader from "../../common/browser/CloudImageBrowserLoader"
import VNZImageSelector from "./VNZImageSelector"

interface Props {
  isLoading: boolean
  imageIds: EntityId[]
  selectedImageIds: EntityId[]
  handleImageSelect: (image: EntityId) => void
  isImportingImages: boolean
  hasSelectedImages: boolean
  handleUploadImages: () => void
  closeCloudProviderModal: () => void
}

const VNZImageBrowserDesktop: React.FC<Props> = ({
  isLoading,
  imageIds,
  selectedImageIds,
  handleImageSelect,
  closeCloudProviderModal,
  handleUploadImages,
  hasSelectedImages,
  isImportingImages,
}) => {
  return (
    <Flex flexDirection="column" flex={1}>
      {/* Fixed height + clip: VirtuosoGrid owns its own scroller; overflow hidden
          keeps the (non-scrolling) loading skeleton from spilling past the bar. */}
      <Flex height="500px" p={4} pt={0} pl={0} overflow="hidden">
        {isLoading && <CloudImageBrowserLoader />}
        {!isLoading && (
          <CloudImageBrowser
            imageIds={imageIds}
            onImageSelect={handleImageSelect}
            selectedImageIds={selectedImageIds}
            imageComponent={VNZImageSelector}
          />
        )}
      </Flex>
      <CloudImageBrowserActionsDesktop
        selectedImageIds={selectedImageIds}
        isImportingImages={isImportingImages}
        hasSelectedImages={hasSelectedImages}
        handleUploadImages={handleUploadImages}
        closeCloudProviderModal={closeCloudProviderModal}
      />
    </Flex>
  )
}

export default VNZImageBrowserDesktop
